var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 124.09",
    style: {
      enableBackground: "new 0 0 122.88 124.09"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.28,6.06l14.38,14.38c1.93,1.93,1.93,5.09,0,7.03L108.63,38.5L87.22,17.1L98.26,6.06 C100.19,4.13,103.35,4.13,105.28,6.06L105.28,6.06z M30.9,16.9l23.3,33.21l28.83-28.83l21.4,21.41L71.86,75.27l15.23,21.7 l-10.49,7.59L60.56,86.58l-23.5,23.5c-1.93,1.93-5.09,1.93-7.02,0L15.65,95.7c-1.93-1.93-1.93-5.09,0-7.03l24.72-24.72L6.05,25.48 C-9.46,7.88,7.03-17.13,30.9,16.9L30.9,16.9z M8.95,94.84l21.5,21.49l-24.42,4.03L8.95,94.84L8.95,94.84L8.95,94.84z M84.47,104.47 c8.47-6.26,14.43-5.63,17.78,1.55c0.79,1.7,3.2,8.98,8.16,12.96c4.87,3.91,12.48,4.45,12.48,4.69 C110.97,124.78,62.03,125.18,84.47,104.47L84.47,104.47L84.47,104.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.8a325d590beee2e6cf6c8ce9deb1040d.svg";
export { ForwardRef as ReactComponent };